import React, { useEffect, useRef } from 'react';
import './Loading.css';

const LogoLoader = () => {
  const logoRef = useRef(null);

  useEffect(() => {
    const logo = logoRef.current;
    if (logo) {
      const length = logo.getTotalLength();
      logo.style.strokeDasharray = length;
      logo.style.strokeDashoffset = length;

      setTimeout(() => {
        logo.style.transition = 'stroke-dashoffset 20s ease-in-out, fill 1s ease-in-out 20s';
        logo.style.strokeDashoffset = '0';
        logo.style.fill = 'white';
      }, 2200);
    }
  }, []);

  return (
    <div className="logo-loader-container">
    <div className="logo-loader">
    <img src="/2.5V.gif" alt="logo-loading" className='logoloadervila'/>
    </div>
    </div>
  );
};

export default LogoLoader;
